<template>

  <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
    <v-toolbar tabs fixed light color="white">
      <v-btn icon @click.native="closeDialog" light>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title v-if="selectedItem.id === 0">Add Offer</v-toolbar-title>
      <v-toolbar-title v-else>Edit Offer - {{selectedItem.offer_number}}</v-toolbar-title>
      <v-spacer/>

      <v-tabs slot="extension"
              v-model="activeTab"
              color="secondary"
              dark
              slider-color="primary"
              class="fixSides"
              show-arrows

      >
        <v-tab>OFFER</v-tab>
        <v-tab :disabled="tabsDisabled">OFFER POSITIONS</v-tab>
        <v-tab :disabled="sendOfferDisabled">SEND OFFER</v-tab>
      </v-tabs>

      <v-toolbar-items>
        <v-menu
          transition="slide-y-transition"
          :nudge-bottom="20"
          :nudge-right="0"
          :nudge-left="0">
          <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                 slot="activator"
                 icon>

            <v-icon dark>more_vert</v-icon>
          </v-btn>
          <v-list v-show="$vuetify.breakpoint.lgAndUp">
            <v-list-tile @click.native="saveAll()">
              <v-list-tile-title>
                <v-icon color="secondary">save</v-icon>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click.native="deleteAll()">
              <v-list-tile-title>
                <v-icon color="red">delete</v-icon>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>

    </v-toolbar>

    <v-tabs-items class="fromTop" v-model="activeTab"
                  :touchless="touchless"
    >
      <v-tab-item>

        <v-layout wrap>
          <v-container grid-list-md>
            <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
              <v-hover>
                <v-card slot-scope="{ hover }"
                        :class="`elevation-${hover ? 4 : 1}`">
                  <v-card-title class="headline">{{cardTitle}} Offer
                    <v-spacer/>
                    <FakeItem v-show="getInitialLoading">
                    </FakeItem>
                    <v-autocomplete v-show="!getInitialLoading"
                                    v-if="selectedItem.id > 0"
                                    class="statusSelecter"
                                    :items="offerStatuses"
                                    item-text="name"
                                    item-value="id"
                                    label="Offer Status"
                                    v-model="selectedItem.customers_offers_status_id"
                                    required
                    />
                  </v-card-title>

                  <v-card-title>


                    <v-flex xs12 pr-3 pl-3
                            v-show="selectedItem.inquiries_id === null || selectedItem.inquiries_id === 0">
                      <v-subheader>RFQ</v-subheader>
                      <v-divider/>
                    </v-flex>


                    <v-flex xs12 md6 pl-4 pa-2
                            v-show="selectedItem.inquiries_id === null || selectedItem.inquiries_id === 0">
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-text-field v-show="!getInitialLoading"
                                    label="Customer RFQ"
                                    v-model="selectedItem.rfq_number"
                                    required
                      />
                    </v-flex>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Customer</v-subheader>
                      <v-divider/>
                    </v-flex>


                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      :items="getCustomers"
                                      label="Customer"
                                      :search-input.sync="searchCustomer"
                                      v-model="selectedItem.customers_id"
                                      :loading="loading"
                                      hide-details
                                      item-value="id"
                                      item-text="name"
                      >
                      </v-autocomplete>

                    </v-flex>
                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      :items="getCustomerBranchOffices"
                                      label="Branch Office"
                                      :search-input.sync="searchCustomerBranchOffice"
                                      v-model="selectedItem.customers_branch_offices_id"
                                      :loading="loading"
                                      hide-details
                                      item-value="id"
                                      item-text="name"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      :items="getCustomerBranchOfficesContacts"
                                      label="Contact Person"
                                      :search-input.sync="searchCustomerBranchOfficeContact"
                                      v-model="selectedItem.customers_branch_offices_contacts_id"
                                      :loading="loading"
                                      :filter="customContactFilter"
                                      hide-details
                                      item-value="id"
                                      item-text="name"
                      >

                        <template slot="selection" slot-scope="data">
                          {{ data.item.title }} {{ data.item.firstname }} {{
                          data.item.lastname }}
                        </template>

                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title
                            >
                              {{ data.item.title }} {{ data.item.firstname }} {{
                              data.item.lastname }}
                            </v-list-tile-title>
                            <!-- <v-list-tile-sub-title>
                                 {{ data.item.email }}
                             </v-list-tile-sub-title>-->
                          </v-list-tile-content>
                        </template>


                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md12 pl-4 pa-2
                            v-show="selectedItem.customer_locale !== null">
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-text-field v-show="!getInitialLoading"
                                    label="Shopify customer Locale"
                                    v-model="selectedItem.customer_locale"
                                    readonly
                      />
                    </v-flex>

                    <v-flex xs12 md12 pl-4 pa-2
                            v-show="selectedItem.customer_comment !== null">
                      <v-subheader>Customer Comment</v-subheader>
                      <v-divider/>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-textarea v-show="!getInitialLoading"
                                  solo
                                  flat
                                  label="Customer comment"
                                  rows="4"
                                  v-model="selectedItem.customer_comment"
                                  readonly
                      />
                    </v-flex>
                    <v-flex xs12 pa-3>
                      <v-subheader>Terms</v-subheader>
                      <v-divider/>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      :items="termsOfDelivery"
                                      item-text="name"
                                      item-value="id"
                                      label="Term of Delivery"
                                      v-model="selectedItem.terms_of_deliveries_id"
                                      required
                      />
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      :items="termsOfPayment"
                                      item-text="name"
                                      item-value="id"
                                      label="Term of Payment"
                                      v-model="selectedItem.terms_of_payments_id"
                                      required
                      />
                    </v-flex>


                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <DatetimePicker v-show="!getInitialLoading"
                                      locale="de-DE"
                                      landscape
                                      dateOnly
                                      mysql
                                      :width="width = 500"
                                      label="Valid Until"
                                      v-model="selectedItem.valid_until"
                                      format="DD.MM.YYYY"
                      >
                      </DatetimePicker>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      v-model="selectedItem.currencies_id"
                                      :items="getCurrencies"
                                      label="Currency"
                                      item-value="id"
                                      item-text="name"
                      />

                    </v-flex>

                    <v-flex xs12 pa-3>
                      <v-subheader>Outgoing Contact</v-subheader>
                      <v-divider/>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pr-4>
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      clearable
                                      v-model="selectedItem.accounts_id"
                                      :items="allAccounts"
                                      label="Account"
                                      item-value="id"
                                      :filter="customContactFilter"
                      >
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ data.item.title ? data.item.title : '' }}
                              {{
                              data.item.firstname }} {{
                              data.item.lastname }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </template>

                        <template slot="selection" slot-scope="data">
                          {{ data.item.firstname }} {{ data.item.lastname }}
                        </template>

                        <template slot="no-data">
                          <v-layout wrap>
                            <v-flex xs12 pl-4 pr-4>
                              <v-btn @click.native="" block
                                     small flat color="secondary">Create
                                New Account
                                <v-icon>add</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </template>
                      </v-autocomplete>
                    </v-flex>


                    <v-flex xs12 pa-3 v-if="selectedItem.id > 0">
                      <v-subheader>Follow Up</v-subheader>
                      <v-divider/>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2 v-if="selectedItem.id > 0">
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <DatetimePicker v-show="!getInitialLoading"
                                      locale="de-DE"
                                      landscape
                                      dateOnly
                                      mysql
                                      :width="width = 500"
                                      label="Follow up Status Reminder"
                                      v-model="selectedItem.customers_offers_follow_up_status_reminder"
                                      format="DD.MM.YYYY"
                      >
                      </DatetimePicker>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2 v-if="selectedItem.id > 0">
                      <FakeItem v-show="getInitialLoading">
                      </FakeItem>
                      <v-autocomplete v-show="!getInitialLoading"
                                      v-if="selectedItem.id > 0"
                                      :items="followUpStatuses"
                                      item-text="name"
                                      item-value="id"
                                      label="Follow Up Status"
                                      v-model="selectedItem.customers_offers_follow_up_status_id"
                                      required
                      />
                    </v-flex>

                    <ProcessHistory
                      v-show="selectedItem.id > 0"
                      :historyTypeID="selectedItem.histories_types_id"
                      :itemID="selectedItem.id"
                      :selectedItem="selectedItemForHistory"
                    />
                  </v-card-title>
                  <v-card-actions>
                    <v-layout mt-2 pb-3 pr-3>
                      <v-spacer/>
                      <v-btn dark color="secondary" @click.native="saveOfferAndGoToNextTab(1)">
                        Save
                        <v-icon class="white--text" right>save</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
              <v-layout mt-5 row justify-end>

              </v-layout>

            </v-flex>

          </v-container>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <offerPositions/>
      </v-tab-item>
      <v-tab-item>
        <sendOfferMessage/>
      </v-tab-item>
    </v-tabs-items>


  </v-card>

</template>

<script>
  import {
    Settings,
    Offer,
    OfferPosition,
    Inquiry,
    Customer,
    CustomerBranchOffice,
    CustomerBranchOfficeContact
  } from '../../store/namespace-helper'
  import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'

  import offerPositions from '../Offers/OfferPositions/OfferPositions.vue'
  import sendOfferMessage from '../Offers/SendOffer/SendOfferMessage.vue'
  import DatetimePicker from '../Shared/DatetimePicker.vue'
  import FakeItem from '../Shared/FakeItem.vue'
  import FakeTable from '../Shared/FakeTable.vue'
  import ProcessHistory from '../Shared/ProcessHistory.vue'

  import _ from 'lodash'

  export default {
    components: {
      offerPositions,
      sendOfferMessage,
      DatetimePicker,
      FakeItem,
      FakeTable,
      ProcessHistory
    },
    mixins: [initialLoadingMixin],
    name: 'add-offer',
    data () {
      return {
        activeTab: 0,
        countries: this.$store.getters.countries,
        salutions: [
          'Mr.',
          'Mrs.'
        ],
        customContactFilter (item, queryText, itemText) {
          const isMatch = (test, query) => {
            return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
          }
          const query = queryText || ''
          const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
          const rc = isMatch(item.firstname, query) ||
            isMatch(item.lastname, query) ||
            isMatch(item.email, query) ||
            isMatch(displayText, query)
          console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
          return rc
        },
        isVisible: false,
        supplierContact: {},
        supplierUpdated: 0,
        onDismissed: false,
        sheet: false,
        searchCustomer: '',
        searchCustomerBranchOffice: '',
        searchCustomerBranchOfficeContact: '',
        valid_until: '',
        offerStatuses: [],
        allAccounts: [],
        followUpStatuses: [],
        selectedItemForHistory: null,
        touchless: true
      }
    },
    mounted () {
      this.loadCurrencies()
      this.loadTermsOfDeliveries()
      this.loadTermsOfPayments()
      this.loadStatuses()
      this.loadFollowUpStatuses()
      this.loadAllAccounts()
      this.loadSelectedItemForHistory()
      this.initialLoadingTimeout(850)
    },
    methods: {
      visibilityChanged (isVisible, entry) {
        if (this.isVisible !== isVisible) {
          this.isVisible = isVisible
          if (isVisible) {
            console.log('tab visible, load data')
            this.loadCurrencies()
            this.loadTermsOfDeliveries()
            this.loadTermsOfPayments()
            this.loadStatuses()
            this.loadFollowUpStatuses()
            this.loadAllAccounts()
            this.loadSelectedItemForHistory()
            this.initialLoadingTimeout(850)
          } else {
            this.supplierUpdated = 0
            this.resetInitialLoadingState()
          }
        }
      },
      closeDialog () {
        this.$store.dispatch(Offer.actions.openCloseDialog)
        this.$store.dispatch(Offer.actions.setSelectedOffer, null)
        this.$store.dispatch(OfferPosition.actions.resetOffersPositions)

        this.activeTab = 0
      },
      loadCustomers () {
        const query = {
          search: this.searchCustomer ? this.searchCustomer : ''
        }
        this.$store.dispatch(Customer.actions.loadCustomers, query)
      },
      throttledLoadItems: _.debounce(function () {
        this.loadCustomers()
      }, 450),
      loadCustomerBranchOffices () {
        this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedItem.customers_id)
      },
      loadCustomerBranchOfficesContacts () {
        this.$store.dispatch(CustomerBranchOfficeContact.actions.loadContactPersons, this.selectedItem.customers_branch_offices_id)
      },
      loadCurrencies () {
        this.$store.dispatch(Settings.actions.loadAllCurrencies)
      },
      loadTermsOfPayments () {
        this.$store.dispatch(Settings.actions.loadTermsOfPayments)
      },
      loadTermsOfDeliveries () {
        this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
      },
      loadStatuses () {
        this.$store.dispatch(Offer.actions.loadStatuses).then(response => {
          this.offerStatuses = response.data.data
        })
      },
      loadFollowUpStatuses () {
        this.$store.dispatch(Offer.actions.loadFollowUpStatuses).then(response => {
          this.followUpStatuses = response.data.data
        })
      },
      loadAllAccounts () {
        this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
          this.allAccounts = response.data.data
        })
      },
      loadSelectedItemForHistory () {
        if (this.selectedItem.id > 0) {
          this.$store.dispatch(Offer.actions.reloadSelectedCustomerOffer, this.selectedItem.id).then(response => {
            this.selectedItemForHistory = response.data.data
          })
        }
      },
      saveOfferAndGoToNextTab (index) {
        let offer = {
          id: this.selectedItem.id,
          customers_id: this.selectedItem.customers_id,
          customers_branch_offices_id: this.selectedItem.customers_branch_offices_id,
          customers_branch_offices_contacts_id: this.selectedItem.customers_branch_offices_contacts_id,
          valid_until: this.selectedItem.valid_until,
          terms_of_payments_id: this.selectedItem.terms_of_payments_id,
          terms_of_deliveries_id: this.selectedItem.terms_of_deliveries_id,
          currencies_id: this.selectedItem.currencies_id,
          customers_offers_status_id: this.selectedItem.customers_offers_status_id,
          accounts_id: this.selectedItem.accounts_id,
          rfq_number: this.selectedItem.rfq_number,
          customers_offers_follow_up_status_id: this.selectedItem.customers_offers_follow_up_status_id,
          customers_offers_follow_up_status_reminder: this.selectedItem.customers_offers_follow_up_status_reminder
        }

        this.$store.dispatch(Offer.actions.saveOffer, offer).then(response => {
          this.activeTab = index
        })
      },
      onDismissedError () {
        this.$store.dispatch(Settings.actions.clearNetworkError)
      },
      openBottomSheet (payload) {
        if (payload) {
          this.$store.dispatch('openCloseBottomSheet')
        }
      }
    },
    computed: {
      dialog () {
        return this.$store.getters[Inquiry.getters.getOpenInquiryDialogState]
      },
      selectedItem () {
        console.log('selected offer: ' + JSON.stringify(this.$store.getters[Offer.getters.getSelectedOffer]))
        return this.$store.getters[Offer.getters.getSelectedOffer]
      },
      getNetworkError () {
        return this.$store.getters[Settings.getters.getNetworkError]
      },
      getCustomers () {
        return this.$store.getters[Customer.getters.customers]
      },
      getCustomerBranchOffices () {
        return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
      },
      getCustomerBranchOfficesContacts () {
        return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
      },
      loading () {
        return this.$store.getters[Settings.getters.loading]
      },
      tabsDisabled () {
        return this.$store.getters[Offer.getters.getSelectedOffer].id === 0
      },
      sendOfferDisabled () {
        return this.$store.getters[Offer.getters.getSelectedOffer].messages_id === null
      },
      getCurrencies () {
        return this.$store.getters[Settings.getters.getAllCurrencies]
      },
      termsOfPayment () {
        return this.$store.getters[Settings.getters.getTermsOfPayments]
      },
      termsOfDelivery () {
        return this.$store.getters[Settings.getters.getTermsOfDeliveries]
      },
      cardTitle () {
        if (this.selectedItem.id === 0) {
          return 'Add new'
        } else {
          return 'Edit'
        }
      }
    },
    watch: {
      searchCustomer: {
        handler (val) {
          console.log('searchCustomer data changed: ' + JSON.stringify(val))
          this.throttledLoadItems()
        },
        deep: true

      },
      'selectedItem.customers_id': {
        handler (val) {
          console.log('selectedCustomer data changed: ' + JSON.stringify(val))
          this.loadCustomerBranchOffices()
        },
        deep: true

      },
      'selectedItem.customers_branch_offices_id': {
        handler (val) {
          console.log('selectedCustomerBranchOffice data changed: ' + JSON.stringify(val))
          this.loadCustomerBranchOfficesContacts()
        },
        deep: true

      }
    }

  }
</script>


<style scoped>

  #menu-button {
    margin-top: 4px;
    width: 55px;
    height: 55px;
  }

  .fromTop {
    padding-top: 120px;
  }

  .fixSides::before {
    position: absolute;
    content: "";
    background-color: var(--secondary-color);
    height: 100%;
    width: 110vw;
    top: 0px;
    left: -24px;
  }

  .statusSelecter {
    width: 80px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddOffer.vue